<i18n>
{
  "en": {
    "terminal": {
      "serialnumber": "Serial number",
      "hardware": "Part number",
      "location": "Location",
      "credit": "Credit history (last 5)"
    },
    "titles": {
      "system": "System",
      "systemcredit": "System Credits",
      "footer": "Press Continue to add credits or time",
      "modalTitle":{
        "credits": "Pulse Credit File",
        "time": "Time License File"
      }
    },
    "labels": {
      "regulatoryAuthority": "Regulatory Authority",
      "licenseaction": "Action",
      "transactionid": "Transaction Reference",
      "time": "Expiration Date of License",
      "credits": "Number of Pulse Credits",
      "note": "Note",
      "mandatory": "(Mandatory)",
      "selectedTime": "No time selected | License selected for {count} day | License selected for {count} days"
    },
    "buttons":{
      "continue": "Continue",
      "back": "Back",
      "setup": "Create configuration",
      "quit": "Quit",
      "time": "Generate Time License",
      "credits": "Generate Pulse Credits",
      "ok": "OK"
    },
    "download": {
      "license": "Download latest configuration file",
      "credit": "Download latest credit file"
    },
    "errors": {
      "credits": "Number of credits must be chosen",
      "time": "Amount of time must be chosen",
      "missingparameter": "The {parameter} of this system is either not set, or does not comply to the specified pattern(s).",
      "noprice": "No pricelist has been uploaded for the system's distributor. Please contact Ellipse.",
      "transactionId_required": "A transaction id is required"
    },
    "texts": {
      "complete": {
        "credits": "A new Pulse Credit file of {numberOfCredits} credits has been created for Candela {systemtype} system of serial number {serialnumber}, located at {location}",
        "time": "A new Time License file of {time} days has been created for Candela {systemtype} system of serial number {serialnumber}, located at {location}"
      },
      "sendmail":{
        "credits": "Copy Pulse Credit file by email to:",
        "time": "Copy Time License file by email to:"
      }
    }
  },
  "da": {
    "terminal": {
      "serialnumber": "Serienummer",
      "hardware": "Part nummer",
      "location": "Lokation",
      "credit": "Credit historik (sidste 5)"
    },
    "titles": {
      "system": "System",
      "systemcredit": "System kredit",
      "footer": "Tryk på Fortsæt for at tilføje kredit eller tid",
      "modalTitle":{
        "credits": "Pulskreditfil",
        "time": "Tidslicensfil"
      }    },
    "labels": {
      "regulatoryAuthority": "Tilsynsmyndighed",
      "licenseaction": "Handling",
      "transactionid": "Transaktionsreference",
      "time": "Udløbsdato for Licens",
      "credits": "Antal Pulskreditter",
      "note": "Note",
      "mandatory": "(Obligatorisk)",
      "selectedTime": "Ingen tid valgt | Licens valgt for {count} dag | Licens valgt for {count} dage"
    },
    "buttons":{
      "continue": "Fortsæt",
      "back": "Tilbage",
      "setup": "Opret konfiguration",
      "quit": "Afslut",
      "time": "Generer tidslicens",
      "credits": "Generer puls kredit",
      "ok": "OK"
    },
    "download": {
      "license": "Download seneste konfigurationsfil",
      "credit": "Download seneste kreditfil"
    },
    "errors": {
      "credits": "Kreditmængde skal vælges",
      "time": "Antal dage skal vælges",
      "missingparameter": "Parametren {parameter} for dette system er enten ikke sat, eller overholder ikke det eller de specificerede mønstre.",
      "noprice": "Der er ikke uploadet en prisliste for det valgte systems distributør. Kontakt venligst Ellipse.",
      "transactionId_required": "Et transaktions id er påkrævet"

    },
    "texts": {
      "complete": {
        "credits": "En ny Pulskredit fil med {numberOfCredits} kredit er blevet lavet til Candela {systemtype} system med serienummer {serialnumber}, placeret ved {location}",
        "time": "En ny Tidslicens fil med {time} dage er blevet lavet til Candela {systemtype}  system med serienummer {serialnumber}, placeret ved {location}"
      },
      "sendmail":{
        "credits": "Kopier kredit fil med email til:",
        "time": "Kopier tidslicens fil med email til:"
      }
    }
  }
}
</i18n>

<template>

  <layout>
    <b-container>
      <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>

      <b-row>
        <b-col lg="8" offset-lg="2"> 
          <system-details :system="system" type="credit" :compact="true"/>

          <div v-if="this.role === 'EllipseAdmin' || this.role === 'CreditDistributor'">

            <b-row>
              <div id="system-credit-header">
                <h1 class="">{{ $t('titles.systemcredit') }}</h1>
              </div>
            </b-row>

            <b-alert show dismissible variant="danger" v-for="error in errors.response.list" v-bind:key="error.Message">{{error.Message}}</b-alert>
 
            <b-row >
              <b-col> <!-- Credits -->
                <b-form-checkbox v-model="useCredits" class="pretty-padding">
                  {{$t('buttons.credits')}}
                </b-form-checkbox>
              </b-col>

              <b-col> <!-- Time -->
                <b-form-checkbox v-model="useTime" class="pretty-padding">
                  {{$t('buttons.time')}}
                </b-form-checkbox>
              </b-col>
            </b-row>

                     
            <!-- Credits -->
            <b-form-group 
                        v-if="this.useCredits"
                        id="fieldsetHorizontal"
                        horizontal
                        :label-cols="4"
                        v-bind:label="$t('labels.credits')"
                        label-for="credits">
              <!--<b-form-input id="credits" v-model="credits">
              </b-form-input>-->
              <b-form-select v-model.number="credits" :options="creditOptions" @change.native="_flush">
              </b-form-select>
              <label class="error-label force-up" v-if="this.errors.credits">
                {{$t('errors.credits_required')}}
              </label>         
            </b-form-group>

            <!-- Time -->
            <b-form-group v-if="this.useTime"
                        id="fieldsetHorizontal"
                        horizontal
                        :label-cols="4"
                        v-bind:label="$t('labels.time')"
                        v-bind:description="$tc('labels.selectedTime', selectedTime)"
                        label-for="time">
                <b-input-group>
              <flat-pickr v-model="time" name="time" class="form-control force-enabled" :config="dateSelectConfig" @on-close="_flush"></flat-pickr>
              <template v-slot:append>
                <b-input-group-text>
                  <font-awesome-icon icon="calendar-alt"/>
                </b-input-group-text>

                <!--<b-input-group-text><strong class="text-danger">!</strong></b-input-group-text>-->
              </template>
            </b-input-group>




              <label class="error-label force-up" v-if="this.errors.time">
                {{$t('errors.time_required')}}
              </label>         




            </b-form-group>

            <b-form-group id="fieldsetHorizontal"
                        horizontal
                        :label-cols="4"
                        v-bind:label="$t('labels.licenseaction')"
                        label-for="licenseActionType"
                        v-if="useCredits">
              <b-form-select id="licenseActionType" v-model="selectedLicenseActionType" :options="licenseActionTypes" class="mb-3" />
            </b-form-group>

            <b-form-group id="fieldsetHorizontal"
                        horizontal
                        :label-cols="4"
                        v-bind:label="$t('labels.transactionid')"
                        v-bind:description="$t('labels.mandatory')"
                        label-for="transactionId">
              <b-form-input id="transactionId" v-model="transactionId">
              </b-form-input>
              <label class="error-label force-up" v-if="this.errors.transactionId">
                {{$t('errors.transactionId_required')}}
              </label> 
            </b-form-group>
          
            <b-form-group id="fieldsetHorizontal"
                        horizontal
                        :label-cols="4"
                        v-bind:label="$t('labels.note')"
                        label-for="note">
              <b-form-textarea id="note" v-model="note">
              </b-form-textarea>
            </b-form-group>

          </div>

          <b-row align-h="between" class="pt-2"><!-- System Buttons -->
            <b-button type="button" variant="outline-secondary" active-class="" class="min-width-button" :to="{ name: 'system-credits-overview', params: { logosid: this.system.LogosID }}">{{$t('buttons.back')}}</b-button>
            <b-button type="submit" variant="outline-secondary" active-class="" class="min-width-button"  v-on:click="save" :disabled="!creditFileEnabled">{{$t('buttons.continue')}}</b-button>
          </b-row>

        </b-col>
      </b-row>
    </b-container>

    <b-modal ref="complete"  hide-footer v-bind:title="modalTitle" hide-header-close>

      <div v-if="this.useCredits" hide-footer>  
        {{
          $t('texts.complete.credits', {
            systemtype: $t('systemtypes.' + this.system.SystemPartNumber),
            serialnumber: this.system.SerialNumber,
            location: this.system.Location,
            numberOfCredits: this.credits,
            price: this.price.Price,
            currency: this.price.Currency
          })
        }}
      </div>

      <div v-if="this.useTime">
        {{
          $t('texts.complete.time', {
            systemtype: $t('systemtypes.' + this.system.SystemPartNumber),
            serialnumber: this.system.SerialNumber,
            location: this.system.Location,
            time: ((files.credit||{}).CreditFile||{}).Amount,
            price: this.price.Price,
            currency: this.price.Currency
          })
        }}
      </div>

      <divider/>

      <b-form-checkbox v-model="sendCreditFileOnMail" class="pt-4" aria-describedby="send mail" aria-controls="send mail" >
        
        <div v-if="this.useCredits" hide-footer>  
          {{ $t('texts.sendmail.credits') }} {{email}}
        </div>

        <div v-if="this.useTime">
          {{ $t('texts.sendmail.time') }} {{email}}
        </div>

      </b-form-checkbox>

      <divider/>

      <b-btn class="mt-3" block variant="outline-success" @click="confirm">{{$t('buttons.ok')}}</b-btn>

    </b-modal>
  </layout>

</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import FileSaver from 'file-saver'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { english } from 'flatpickr/dist/l10n/default.js';

import Layout from './Layout'
import SystemDetails from './subcomponent/SystemDetails'
import elg from '../api/elg.gateway.js'
import jwt from '../utils/jwt.js'

export default {
  components: {
    flatPickr,

    Layout,
    SystemDetails,
    Loading
  },

  data() {
    return {
      creditFileEnabled: true, 

      isLoading: false,

      limits: {},
      
      system: {},
      files: {
        license: undefined,
        credit: undefined
      },
      useCredits: true,
      creditOptions: [],
      sendCreditFileOnMail: false,

      transactionId: undefined,
      note: undefined,
      
      credits: undefined,
      price: {},
      time: undefined,

      errors: {
        credits: undefined,
        time: undefined,
        transactionId: undefined,
        response: {
          list: [],
          message: undefined
        }
      },

      licenseActionTypes: [],
      selectedLicenseActionType: undefined,
    };
  },

  methods: {
    _flush() {
      this.errors.credits = false;
      this.errors.time = false;
    },
    validate(){
      if(this.useCredits === true && this.credits === undefined){
        this.errors.credits = true;
        return false;
      }

      if(this.useCredits === false && this.time === undefined){
        this.errors.time = true;
        return false;
      }

      if(this.transactionId === '' || this.transactionId === undefined){
        this.errors.transactionId = true;
        return false;
      }

      return true;
    },
    save(){
      this._flush();

      if( !this.validate() ){
        return;
      }

      this.isLoading = true;
      var data = {
        LogosID: this.system.LogosID,
        TransactionID: this.transactionId,
        Note: this.note,
        IssueInformation: {
          LicenseType: 'Credit',
          LicenseActionType: this.selectedLicenseActionType
        },
        SystemInformation: {
          SerialNumber: this.system.SerialNumber,
          InstallationId: this.system.InstallationID,
          SystemPartNumber: this.system.SystemPartNumber,
          SystemDongle: this.system.SystemDongle
        },
        Choice: {
          Credits: undefined,
          Time: undefined
        }
      }

      if( this.useCredits === true ){
        data.Choice.Credits = this.credits;
      }else{
        data.Choice.Time = this.time;
      }

      elg()
      .post('/api/v1/credit', data)
      .then( res => {
        this.isLoading = false;
        this.files.credit = res.data.File;
        this.$refs.complete.show();
      })
      .catch( err => {
        this.isLoading = false;

        if(err.response.data.Message === 'No price'){
 
          this.errors.response.list.push({
            Message:  this.$i18n.t('errors.noprice')
          })

        }else{
          this.errors.response.list.push(err.response.data);
          for( var i = 0; i < err.response.data.Errors.length; i++){
            this.errors.response.list.push(err.response.data.Errors[i]);
          }
        }
      })
    },
    confirm(){
      if(this.sendCreditFileOnMail){
        var key = 'credits';
        if(this.useTime)
          key = 'time'

        var subject = this.$t(`titles.modalTitle.${key}`);

        var body = this.$t(`texts.complete.${key}` , {
          systemtype: this.$t('systemtypes.' + this.system.SystemPartNumber),
          serialnumber: this.system.SerialNumber,
          location: this.system.Location,
          numberOfCredits: this.credits,
          price: this.price.Price,
          currency: this.price.Currency,
          time: this.selectedTime
        });

        var data = {
          Recipient: this.email,
          Subject: subject,
          Body: body
        };
        
        elg()
        .post(`/api/v1/files/${this.files.credit.FileID}/mail`, data)
        .then( res => {
          this.hidePopup();
        });
      } else {
        this.hidePopup();
      }
    },
    hidePopup(){
      this.$refs.complete.hide();
      this.$router.push({
        name: 'systems',
        params:{
          logosid: this.system.LogosID
        }
      })

    },
    downloadLicenseFile(){
      elg()
      .get('/api/v1/files/' + this.files.license.FileID)
      .then((response) => {
        FileSaver.saveAs(new Blob([response.data]), this.files.license.Filename);
      });
    },
    downloadCreditFile(){
      elg()
      .get('/api/v1/files/' + this.files.credit.FileID)
      .then((response) => {
        FileSaver.saveAs(new Blob([response.data]), this.files.credit.Filename);
      });
    }
  },

  mounted() {  
    elg()
    .get(`/api/v1/systems/${this.$route.params.logosid}`)
    .then( res => {
      this.system = res.data;

      if(this.system.SerialNumber == undefined){
        this.errors.response.list.push({
        	Message: this.$i18n.t('errors.missingparameter', { parameter: 'SerialNumber' })
        })
        this.creditFileEnabled = false;
      }
      if(this.system.SystemPartNumber == undefined){
        this.errors.response.list.push({
        	Message: this.$i18n.t('errors.missingparameter', { parameter: 'SystemPartNumber' })
        })
        this.creditFileEnabled = false;
      }
      if(this.system.SystemDongle == undefined){
        this.errors.response.list.push({
        	Message: this.$i18n.t('errors.missingparameter', { parameter: 'SystemDongle' })
        })
        this.creditFileEnabled = false;
      }

      if(this.system.InstallationID == undefined){
        this.system.InstallationID = '0000-0000-0000-0000-00';
      }
      
      elg()
      .get(`/api/v1/users/me`)
      .then( res => {
        this.limits = res.data.Limits;
        
        elg()
        .get('/api/v1/credit/config')
        .then( res => {
          for(var i = 0; i < res.data.LicenseActionTypes.Enum.length; i++){
            this.licenseActionTypes.push(res.data.LicenseActionTypes.Enum[i]);
          }
          this.selectedLicenseActionType = this.licenseActionTypes[0];

          for(var i = 0; i < res.data.CreditsType.Enum.length; i++){
            if( this.limits.MaxCredits === undefined || res.data.CreditsType.Enum[i] <= this.limits.MaxCredits ){
              this.creditOptions.push(res.data.CreditsType.Enum[i]);
            }
          }

        });

      }); // End ELG.Get Users me

    });
  },

  computed: {
    role() {
      return jwt.getRole()
    },
    email(){
      return jwt.getEmail();
    },
    logosid () {
      return this.$route.params.logosid
    },
    useTime: {
      get: function() {
        return !this.useCredits
      },
      set: function(newValue){
        this.useCredits = !newValue;
      }
    },
    dateSelectConfig() {
      var FlatpickrLanguageMap = {
        "da": Danish,
        "en": english
      };

      var config = {
        minDate: moment().add(1, 'days').toDate(),
        locale: FlatpickrLanguageMap[this.$root.$i18n.locale]
      }
      
      if( this.limits.MinTime !== null && this.limits.MinTime !== undefined ){
        config.minDate  = moment().add(Math.max(this.limits.MinTime, 1), 'days').toDate();
      }
      
      if( this.limits.MaxTime !== null && this.limits.MaxTime !== undefined ){
        config.maxDate  = moment().add(this.limits.MaxTime, 'days').toDate();
      }

      return config;
    },
    selectedTime(){
      if(this.time === undefined)
        return 0;
      
      var now = moment().startOf('day');
      var days = Math.abs(now.diff(moment(this.time).startOf('day'), 'days'));

      return days;
    },
    modalTitle(){
      if(this.useTime){
        return this.$t('titles.modalTitle.time');
      }else{
        return this.$t('titles.modalTitle.credits');
      }
    }
  },
};
</script>

<style scoped>

#system-credit-header,
#system-header {
  margin-top: 18px;
  background-color: lightgrey;
  border-radius: 5px 5px 5px 5px;
  height: 75px;
  margin-bottom: 20px;
  width:100%;
}

#system-credit-header > h1,
#system-header > h1{
  padding-top: 10px;
  padding-left: 15px;

  color: #8C8C8C;
  font-weight: bold;
}

#system-footer{
  height: 40px;
  margin: 0;
  background-color: darkgrey;
  margin-bottom: 20px;
  width:100%;
}

#system-footer > h6 {
  color: black;
  font-weight: normal;
  padding-left:15px;
  padding-top:10px;
}

.pretty-padding {
  padding-bottom: 20px;
}
.button-spacing {
  margin-right: 35px;
}

.force-enabled {
  background-color: #fff;
}

</style>


// WEBPACK FOOTER //
// WebApp/components/IssueSystemCredits.vue